import { useRef, useEffect } from 'react'

export const useInterval = (callback, delay) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (delay == null) return

    const tick = () => savedCallback.current?.()
    const id = setInterval(tick, delay)

    return () => clearInterval(id)
  }, [delay])
}
